import { PackagesService } from '@/backend/market'
import { LivePackageRepository } from '../../domain/repositories/LivePackageRepository'
import type { LivePackageFilterEntity } from '../../domain/entities/LivePackageFilterEntity'
import { LivePackageFilterModel } from '../models/LivePackageFilterModel'
import { LivePackageResponseModel } from '../models/LivePackageResponseModel'

export class LivePackageRepositoryImpl implements LivePackageRepository {
  async getLivePackage(
    filterData: LivePackageFilterEntity
  ): Promise<LivePackageResponseModel | { error: true }> {
    const filterModel = new LivePackageFilterModel(filterData)
    try {
      const response = await PackagesService.getStreamingPackagesAdmin(filterModel)
      const livePackageResponseModel = new LivePackageResponseModel(response)

      return livePackageResponseModel
    } catch {
      return { error: true }
    }
  }
  async watchPackage(packageId: string): Promise<{ success: true } | { error: true }> {
    try {
      await PackagesService.postPackageTrackingAdmin({ id: packageId })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
